import { render } from "./NavbarBook.vue?vue&type=template&id=01f4e628"
import script from "./NavbarBook.vue?vue&type=script&lang=js"
export * from "./NavbarBook.vue?vue&type=script&lang=js"

import "./NavbarBook.vue?vue&type=style&index=0&id=01f4e628&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__